import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, NgForm, Validators } from '@angular/forms';
import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/_core/auth.service';
import { EntityService } from 'src/app/_core/entity.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';

import { routerTransition } from 'src/app/_core/static/animations';

@Component({
    selector: 'app-shared-order-create',
    templateUrl: './shared-order-create.component.html',
    styleUrls: ['./shared-order-create.component.scss'],
    host: {
        //'class': 'host-default',
        '[@routerTransition]': '',
    },
    animations: [
        routerTransition
    ],
    standalone: false
})
export class SharedOrderCreateComponent  {
	$storage: any;
	loading = true;
	userDetails: any = {};
	tpConfig: any = {};
	tpAccount: any;
	hideUI: boolean;
	tableId: string;
	tableNum: string;
	minAmount: number = 50;
	maxAmount: number = 1000;
	amountText: string = '';


	infoSteps = [
		{c:'OAT.desc_a', icon:'cc'},
		{c:'OAT.desc_b', icon:'utensils'},
		{c:'OAT.desc_c', icon:'dollar'},
	]

	public contactForm;

	constructor(
		public appService: AppService,
		public authService: AuthService,
		public entityService: EntityService,
		public dialogsService: DialogsService,
		public tabitPayService: TabitPayService,
	) {
		this.$storage = this.tabitPayService.$storage;
		this.tpConfig = _.get(this.$storage.site, 'tabitpay', {});
		this.tableId = this.appService.urlParams.tableid;
		this.tableNum = !this.tableId && this.appService.urlParams.table
		this.start();
	}

	async start() {
		if (!this.$storage.site) {
			this.appService.startBlock();
			try {
				let site = await this.entityService.getSiteConfig(this.appService.getOrganization())

				this.tabitPayService.start(site);
				this.$storage = this.tabitPayService.$storage;
				this.tabitPayService.canCreateTabOrder(this.$storage.site);
				this.tpConfig = _.get(this.$storage.site, 'tabitpay', {});
				this.appService.stopBlock();
			} catch (err) {
				this.appService.backToSiteStart();
				return;
			}
		}

		try {
			const loginResponse = await this.dialogsService.signInPrompt(this.$storage.contact, 'tabOrder');
			if (loginResponse?.anonymous) {
				if (!this.tabitPayService.canCreateEatinOrder()) throw ({  });
				const orderResponse = await this.appService.confirm({ html: this.appService.translate('OAT.share_anonymous_prompt'), confirmText: 'OAT.order_anonymous_from_the_menu' });
				if (!orderResponse) throw ({  });
				this.appService.createEatinOrder(true);

			} else {
				this.loading = false;
				this.init();
			}
		} catch (e) {
			this.appService.goBack();
		}


	}

	init() {

		const phone = localStorage.getItem('c_phone') || '';
		const name = localStorage.getItem('c_name') || '';

		let controls: any = {
			phone: new UntypedFormControl(phone, [Validators.required]),
			name: new UntypedFormControl(name, [Validators.required]),
			tabName: new UntypedFormControl(this.appService.translate('OAT.default_tab_name', {name:name}).substring(0,30), [Validators.required, Validators.maxLength(30)]),
		}
		if (!this.tableId && !this.tableNum) {
			controls.tableNumber = new UntypedFormControl('', !this.tableId ? [Validators.required, Validators.pattern('[0-9]*')] : null)
		}
		this.tpAccount = this.tpConfig.tabPaymentAccount;
		if (this.tpAccount) {
			controls.amountLimit = new UntypedFormControl(this.tpConfig.preAuthPaymentAccount || '', [Validators.required, Validators.pattern('[0-9]*'), Validators.min(this.minAmount), Validators.max(this.maxAmount)]);
			this.amountText = this.appService.translate('GROUP_VALIDATION.between_amount', {
				min: this.appService.parseCurrency(this.minAmount),
				max: this.appService.parseCurrency(this.maxAmount)
			})
		} else {
			this.infoSteps.shift();
		}
		this.contactForm = new UntypedFormGroup(controls);
	}

	get amountLimit() {
		if (!this.tpAccount) return;
		if (this.tpAccount.supportPreAuthAmount) {
			return this.contactForm.get('amountLimit');
		} else {
			return {value:this.tpAccount.fixedPreAuthAmount}
		}
	}
	get tabName() {
		return this.contactForm.get('tabName');
	}

	createSharedOrder() {
		if (!this.contactForm.valid) {
			_.each(this.contactForm.controls, (val, key) => {
				val.markAsTouched({ onlySelf: true });
			})
			return;
		}

		const phone = this.contactForm.value.phone;
		this.userDetails.phone = phone;
		//localStorage.setItem('c_phone', phone);

		const name = this.contactForm.value.name;
		this.userDetails.name = name;
		//localStorage.setItem('c_name', name);

		this.createTabOrder({
			contact: this.userDetails,
			amountLimit: this.amountLimit?.value,
			tableNumber: this.contactForm.value.tableNumber,
			tabName: this.contactForm.value.tabName,
			orderId: this.appService.getObjectId(),
			tableId: this.tableId,
			tableNum: this.tableNum,
		});
	}

	createTabOrder(args) {

		this.appService.startBlock({ class: 'dark-block' });
		this.tabitPayService.createTabOrder(args).then(resultOrder => {
			let params = {
				site: this.$storage.organization,
				oid: resultOrder["_id"]
			}
			sessionStorage.setItem('firstLoad', params.oid);
			let resultURL = `${document.location.origin}/?site=${params.site}&oid=${params.oid}`;
			document.location.replace(resultURL);
		}).catch(err => {
			this.appService.stopBlock();
			if (!err) err = {};
			if (err.type == "CANCELED") return;
			const errorCode = err?.error?.code;
			let message;

			if (!args.verificationCode) {
				switch (errorCode) {
					case 409144:
						return this.dialogsService.showSMSDialog({
							isRetry: args.isRetry,
							phone: this.userDetails.phone
						}).then(response => {
							if (response === "resend") {
								args.isRetry = true;
								return this.createTabOrder(args);
							}
							args.verificationCode = response;
							return this.createTabOrder(args);
						}).catch(err => {
							throw ({ type: 'CANCELED' });
						});
					case 404001:
						if (args.tableNum) {
							message = this.appService.translate('MESSAGES.TABLE_X_NOT_FOUND', {v:args.tableNum});
						}
						break;
				}
			}
			if (!message) message = _.get(_.get(err, "error", err), "message", "Failed to create order");
			this.appService.alert({ "content": message });
		})
	}



}
